/* eslint-disable no-nested-ternary */
import PropTypes from "prop-types";
import makeComponentTrashable from "trashable-react";
import { useTranslation } from "Shared/util/custom-hooks";
import { SettingsCard } from "Shared/components/cards";
import { UserRole, getUserRole } from "./user-administration-utils";

const resolveUserRoleText = (userRole, t) => {
    switch (userRole) {
        case UserRole.ADMIN:
            return t.administrator;
        case UserRole.USER:
            return t.user;
        default:
            return UserRole.UNKNOWN;
    }
};

const getStatusData = (user, activeUserId, t) => {
    const isActiveUser = user.id === activeUserId;
    return {
        type: isActiveUser ? "DEFAULT" : user.disabled ? "INVALID" : "VALID",
        text: isActiveUser
            ? t.my_account
            : user.disabled
            ? t.not_activated
            : t.active,
    };
};

const UserSettingsCard = ({
    user,
    activeUserId,
    activeUgId,
    onClick,
    className,
}) => {
    const t = useTranslation((x) => x.manage_users);

    const handleOnClick = () => onClick(user);

    const { type, text } = getStatusData(user, activeUserId, t);
    const headerText = `${user.firstName} ${user.lastName}`;
    const userRoleText = resolveUserRoleText(getUserRole(user, activeUgId), t);

    return (
        <SettingsCard
            key={user.id}
            status={{
                type,
                text,
            }}
            header={{
                text: headerText,
            }}
            content={userRoleText}
            action={{
                text: t.edit,
                svg: "/edit.svg",
                onClick: handleOnClick,
            }}
            className={className}
        />
    );
};

UserSettingsCard.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        disabled: PropTypes.bool,
    }).isRequired,
    activeUserId: PropTypes.number.isRequired,
    activeUgId: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

export default makeComponentTrashable(UserSettingsCard);
